import { render, staticRenderFns } from "./systemFromInfo.vue?vue&type=template&id=3fdaa4b5&scoped=true"
import script from "./systemFromInfo.vue?vue&type=script&lang=js"
export * from "./systemFromInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdaa4b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/yunxiao/be-3sdnltdmmjqei95chipgpfz5/runner/__flow_work/__flow_builds/182a3969-2a32-4dff-94d8-cf1bbedf203a/workspace/crmeb-mer-admin_BNnv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fdaa4b5')) {
      api.createRecord('3fdaa4b5', component.options)
    } else {
      api.reload('3fdaa4b5', component.options)
    }
    module.hot.accept("./systemFromInfo.vue?vue&type=template&id=3fdaa4b5&scoped=true", function () {
      api.rerender('3fdaa4b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/systemFromInfo.vue"
export default component.exports